/**************************************************************************************************/
/** @import Node Packages                                                                        **/
/**************************************************************************************************/
import { defineComponent } from 'vue'

/**************************************************************************************************/
/** @import Components/Global                                                                    **/
/**************************************************************************************************/
import * as CompanyLogo from '@/Components/Global/CompanyLogo/template.vue'

/**************************************************************************************************/
/** @import Constants                                                                            **/
/**************************************************************************************************/
import { VersionTracking } from '@/Constants/VersionTracking'

/**************************************************************************************************/
/** @import Mixins                                                                               **/
/**************************************************************************************************/
import MixinResponsive from '@/Mixins/MixinResponsive'

/**************************************************************************************************/
/** @internal Const @name LoginFooter                                                            **/
/**************************************************************************************************/
const LoginFooter = defineComponent(
{
	/*************************************************/
	/** @Properties                                 **/
	/*************************************************/
	name: 'LoginFooter', mixins: [MixinResponsive],

	components:
	{
		CompanyLogo: CompanyLogo.default
	},

	/*************************************************/
	/** @Computed                                   **/
	/*************************************************/
	computed:
	{
		GetBuildVersionCode() : number
		{
			return VersionTracking.CurrentBuild
		},

		GetBuildVersionName() : string
		{
			return VersionTracking.CurrentVersion
		}
	}
})

/**************************************************************************************************/
/** @export Component @name LoginFooter                                                          **/
/**************************************************************************************************/
export default LoginFooter

/**************************************************************************************************/
/** @export Type @name LoginFooterRef                                                            **/
/**************************************************************************************************/
export type LoginFooterRef = InstanceType<typeof LoginFooter>